import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formElement", "displayValue", "clear"]

  connect() {
    if($(this.element).hasClass('disabled')){
      return
    }

    this.formElementTarget.addEventListener('blur', this.onBlur, true)
    this.formElementTarget.addEventListener('keypress', this.onKeyPress, true)
    this.prepareInput()

    if (!this.element.dataset.transient || this.element.dataset.transient == "false") {
      this.element.setAttribute("data-reflex-permanent", true)
    }
  }

  onBlur = (e) => {
    if($(this.element).hasClass('disabled')){
      return
    }

    if(this.hasClearTarget && e.relatedTarget == this.clearTarget){
      this.clearInput(e)
    }else{
      this.hideInput(e)
    }
  }

  onKeyPress = (e) => {
    if($(this.element).hasClass('disabled')){
      return
    }

    if(this._enterPressed(e)){
      e.preventDefault()
      e.stopPropagation()
      this.hideInput(e)
      return false
    }
  }

  showInput(e) {
    if($(this.element).hasClass('disabled')){
      return
    }

    $(this.element).removeClass("selected")
    
    if (this.hasClearTarget) {
      $(this.clearTarget).removeClass("d-none")
    }

    $(this.displayValueTarget).addClass("d-none")
    $(this.formElementTarget).val(this.formElementTarget.value.trim()).removeClass("d-none").focus()

    if(!$(this.formElementTarget).val()){
      $(this.formElementTarget).val(this.data.get("defaultValue"))
    }
  }

  prepareInput() {
    if($(this.element).hasClass('disabled')){
      return
    }

    let input = $(this.formElementTarget)
    let display = $(this.displayValueTarget)
    
    if (this.hasClearTarget) {
      let clear = $(this.clearTarget)
      clear.addClass("d-none")
    }

    let inputValue = this.formElementTarget.value.trim()

    if(inputValue != ""){
      if($(input).is("select")){
        display.text($(input).find("option:selected").text())
      }else{
        display.text(input.val().trim())
      }

      $(this.element).addClass("selected")
    }else{
      display.text(input.attr('placeholder'))
      $(this.element).removeClass("selected")
    }

    input.addClass("d-none")
    display.removeClass("d-none")
  }
  
  clearInput(e) {
    if($(this.element).hasClass('disabled')){
      return
    }

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    let input = $(this.formElementTarget)
    let clear = $(this.clearTarget)

    input.val("")
    this.hideInput()
  }

  hideInput(e) {
    if($(this.element).hasClass('disabled')){
      return
    }
    
    this.prepareInput()

    if (this.hasClearTarget) {
      $(this.clearTarget).addClass("d-none")
    }

    let event = new Event('change', { bubbles: true })
    this.formElementTarget.dispatchEvent(event)
  }

  _enterPressed(e) {
    return e.keyCode === 13
  }
}
